import { Component, Prop, h, State } from '@stencil/core';
import { INavbarItem } from './menu-item/navbar-item';

@Component({
  tag: 'lab-ds-navbar',
  styleUrl: 'lab-ds-navbar.css',
  shadow: true,
})
export class LabDsNavbar {
  @State() collapsed = true;

  @Prop() menus: Array<INavbarItem>;

  @Prop() user?: { name: string; unitName: string };

  @Prop() logo: string;

  @State() currentHost = window.location;

  @Prop() activeUrl: string = window.location.href;

  @Prop() activeProductsV4!: boolean;

  @Prop() activeRedeV4!: boolean;

  @State() openProductsV4: boolean = false;

  @State() openRedeV4: boolean = false;

  render() {
    let openIconProductsV4 = this.openProductsV4 ? 'expand_less' : 'expand_more';
    let openIconRedeV4 = this.openRedeV4 ? 'expand_less' : 'expand_more';
    return (
      <div class={`v4-navbar notranslate`}>
        <nav>
          <ul>
            <li class={`${this.activeProductsV4 ? 'active' : ''} ${this.openProductsV4 ? 'open' : ''} menu-item`}>
              <a
                onClick={() => {
                  this.openProductsV4 = !this.openProductsV4;
                  this.openRedeV4 = false;
                }}
              >
                <div class="menu-option">
                  <lab-ds-icon-not-selectable icon="lightbulb" size="s-medium" />{' '}
                  <span class="title-menu">
                    Produtos V4 <lab-ds-icon-not-selectable icon={openIconProductsV4} size="small" />
                  </span>
                </div>
              </a>
              <ul class="submenu">
                <slot name="products-v4"></slot>
              </ul>
            </li>
            <li class={`${this.activeRedeV4 ? 'active' : ''} ${this.openRedeV4 ? 'open' : ''} menu-item`}>
              <a
                onClick={() => {
                  this.openRedeV4 = !this.openRedeV4;
                  this.openProductsV4 = false;
                }}
              >
                <div class="menu-option">
                  <lab-ds-icon-not-selectable icon="share" size="s-medium" />{' '}
                  <span class="title-menu">
                    Rede V4 <lab-ds-icon-not-selectable icon={openIconRedeV4} size="small" />
                  </span>
                </div>
              </a>
              <ul class="submenu">
                <slot name="rede-v4"></slot>
              </ul>
            </li>
          </ul>
        </nav>
        <div class="footer">
          <div class="user-data">
            <span>{this.user?.name}</span>
            <span>{this.user?.unitName}</span>
          </div>
          <img width={20} src={this.logo} alt="Logo da V4" />
        </div>
      </div>
    );
  }
}
